"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Card_1 = require("@material-ui/core/Card");
const mediaUtil_1 = require("@pbl/pbl-react-core/lib/utils/mediaUtil");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const package_1 = require("../package");
const StoreCard = ({ onClick, title, image, amount, price, classes, t }) => {
    const baseUri = !!package_1.config.internalConfig.BASE_URL ? package_1.config.internalConfig.BASE_URL : '';
    const imageUrl = !!image
        ? (0, mediaUtil_1.createMediaURL)(baseUri, '/media/api/file/', image)
        : package_1.assets.internalAssets.noImage;
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, Object.assign({ className: (0, classnames_1.default)(classes.card, 'po-widget-card') }, { children: [(0, jsx_runtime_1.jsx)(core_1.CardMedia, { className: classes.media, image: imageUrl }), (0, jsx_runtime_1.jsx)(core_1.CardContent, Object.assign({ className: classes.content }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.amount }, { children: (0, jsx_runtime_1.jsxs)(core_1.Button, Object.assign({ variant: 'contained', size: 'large', color: 'primary', className: classes.addBtn, onClick: onClick }, { children: [t('store.shoppingCart.add'), " ", price.toCurrencyFormat()] })) })) }))] })));
};
const styles = (theme) => (0, core_1.createStyles)({
    media: {
        height: 265.5,
        display: 'flex',
        [theme.breakpoints.down('lg')]: {
            height: 220.5
        },
        [theme.breakpoints.down('md')]: {
            height: 337
        },
        [theme.breakpoints.down('sm')]: {
            height: 115,
            width: 115
        }
    },
    card: {
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        backgroundColor: theme.palette.primary.dark,
        borderRadius: 10
    },
    content: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            display: 'flex'
        },
        [theme.breakpoints.down('xl')]: {
            display: 'flex',
            justifyContent: 'center'
        }
    },
    points: {
        padding: theme.spacing(),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: 6,
        minWidth: 66
    },
    amount: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    amountTxt: {
        [theme.breakpoints.down('sm')]: {
            minWidth: 31
        }
    },
    addBtn: {
        marginLeft: theme.spacing(),
        padding: theme.spacing(1.5),
        paddingLeft: theme.spacing(3.5),
        paddingRight: theme.spacing(3.5),
        '@media (max-width:380px)': {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            width: '170px'
        },
        [theme.breakpoints.between('md', 'lg')]: {
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5)
        },
        [theme.breakpoints.between('md', 'lg')]: {
            width: '100%'
        }
    }
});
exports.default = (0, core_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(StoreCard));
//# sourceMappingURL=StoreCard.js.map